import type { ProductsTranslations } from '../interfaces/products';

export const productsTranslations: ProductsTranslations = {
  page_title: 'Catálogo',
  page_description:
    'Estos son los productos que Luna y tus otros agentes pueden recomendar y vender.',
  stat_active: 'Productos activos',
  stat_draft: 'Borradores',
  stat_low_stock: 'Stock bajo',
  stat_out_of_stock: 'Agotados',
  filter_all: 'Todos',
  filter_active: 'Activos',
  filter_draft: 'Borradores',
  filter_archived: 'Archivados',
  filter_category_all: 'Todas las categorías',
  sort_recent: 'Recientes',
  sort_best_sellers: 'Más vendidos',
  sort_low_stock: 'Stock bajo',
  sort_price_high: 'Precio mayor',
  sort_price_low: 'Precio menor',
  sort_name_az: 'Nombre A–Z',
  search_placeholder: 'Buscar por nombre, SKU o etiqueta…',
  view_list: 'Vista de lista',
  view_grid: 'Vista de cuadrícula',
  action_new_product: 'Nuevo producto',
  action_export_csv: 'Exportar CSV',
  action_import: 'Importar',
  action_edit: 'Editar',
  action_duplicate: 'Duplicar',
  action_delete: 'Eliminar',
  action_change_status: 'Cambiar estado',
  action_assign_category: 'Asignar categoría',
  action_channel_availability: 'Disponibilidad por canal',
  bulk_selected: '{{count}} seleccionados',
  bulk_clear: 'Limpiar selección',
  table_product: 'Producto',
  table_category: 'Categoría',
  table_status: 'Estado',
  table_price: 'Precio',
  table_stock: 'Stock',
  table_channels: 'Canales',
  table_actions: 'Acciones',
  stock_in_stock: 'En stock',
  stock_low: 'Bajo',
  stock_out: 'Agotado',
  status_active: 'Activo',
  status_draft: 'Borrador',
  status_archived: 'Archivado',
  form_title_new: 'Nuevo producto',
  form_title_edit: 'Editar producto',
  form_subtitle:
    'Lo que cargues aquí va al catálogo que Luna y tus otros agentes usan para responder, recomendar y cerrar ventas.',
  section_basic_info: 'Información básica',
  section_basic_info_subtitle: 'Lo primero que ven tus agentes y clientes.',
  section_images: 'Imágenes y media',
  section_images_subtitle:
    'Sube hasta 15 imágenes. La primera será la portada.',
  section_pricing: 'Precio',
  section_pricing_subtitle: 'El margen lo calculamos automáticamente.',
  section_inventory: 'Inventario y envío',
  section_variants: 'Variantes',
  section_variants_subtitle:
    'Crea opciones (talla, color, aroma…) y se generarán todas las combinaciones.',
  section_seo: 'SEO y contexto para agentes',
  section_seo_subtitle:
    'Lo que verá Google y lo que sabrán tus agentes que no se muestra al cliente.',
  field_name: 'Nombre del producto',
  field_name_placeholder: 'Ej. Vela aromática edición otoño',
  field_description: 'Descripción',
  field_description_placeholder:
    'Lo que tu agente leerá para responder preguntas',
  field_category: 'Categoría',
  field_brand: 'Marca',
  field_tags: 'Etiquetas',
  field_tags_placeholder: 'Escribe y presiona Enter…',
  field_currency: 'Moneda',
  field_price: 'Precio',
  field_compare_price: 'Precio de comparación',
  field_compare_price_hint: 'Mostrado tachado',
  field_cost_per_unit: 'Costo por unidad',
  field_cost_per_unit_hint: 'No se muestra al cliente',
  field_margin: 'Margen',
  field_profit: 'Ganancia',
  field_tax_toggle: 'Cobrar impuestos sobre este producto',
  field_sku: 'SKU',
  field_sku_hint: 'Único — sincroniza con Shopify',
  field_barcode: 'Código de barras (ISBN/UPC)',
  field_track_inventory: 'Llevar control de inventario',
  field_track_inventory_hint: '{{brand}} avisará cuando bajen las existencias.',
  field_continue_selling: 'Seguir vendiendo sin stock',
  field_continue_selling_hint: 'Útil para preventas o backorder.',
  field_stock: 'Stock disponible',
  field_low_stock_threshold: 'Avisar bajo stock en',
  field_warehouse: 'Almacén',
  field_is_physical: 'Es un producto físico',
  field_is_physical_hint: 'Activa peso y dimensiones para calcular envío.',
  field_weight: 'Peso',
  field_length: 'Largo',
  field_width: 'Ancho',
  field_height: 'Alto',
  field_has_variants: 'Este producto tiene variantes',
  field_has_variants_hint:
    'Si no, vendes una sola versión y bastará con el precio + stock de arriba.',
  field_option_name: 'Nombre de opción',
  field_add_value: 'Agregar valor',
  field_add_option: 'Añadir otra opción',
  field_remove_option: 'Quitar opción',
  field_variant_name: 'Variante',
  field_variant_price: 'Precio',
  field_variant_sku: 'SKU',
  field_variant_stock: 'Stock',
  field_show_more_variants: '+ {{count}} variantes más · Ver todas',
  field_seo_title: 'Título SEO',
  field_seo_title_hint: '60 caracteres recomendados',
  field_meta_description: 'Meta descripción',
  field_meta_description_hint: '155 caracteres recomendados',
  field_agent_notes: 'Notas internas para el agente',
  field_agent_notes_hint: 'Solo tu equipo y tus agentes lo ven',
  field_seo_suggest_ai: 'Sugerir con IA',
  sidebar_status: 'Estado',
  sidebar_status_active: 'Activo — visible para agentes',
  sidebar_status_draft: 'Borrador — solo tú',
  sidebar_status_archived: 'Archivado',
  sidebar_channels: 'Disponible en',
  sidebar_visible_to_agents: 'Agentes con acceso',
  sidebar_visible_to_agents_all_label: 'Todos los agentes',
  sidebar_visible_to_agents_hint:
    'Activa "Todos los agentes" para que cualquier agente lo recomiende. Apágalo para elegir agentes específicos.',
  sidebar_visible_to_agents_empty:
    'Aún no hay agentes ecommerce. Crea uno para asignar visibilidad.',
  sidebar_checklist: 'Lista de verificación',
  sidebar_checklist_subtitle: '{{done}} de {{total}} completados',
  sidebar_ai_title: '{{brand}} AI puede ayudarte',
  sidebar_ai_description:
    'Pega una URL, una foto o describe el producto y generamos nombre, descripción, etiquetas y SEO en segundos.',
  sidebar_ai_button: 'Generar con IA',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram DM',
  channel_web: 'Web chat',
  channel_shopify: 'Tienda Shopify',
  checklist_name: 'Nombre y descripción',
  checklist_image: 'Al menos 1 imagen',
  checklist_price: 'Precio definido',
  checklist_sku: 'SKU para inventario',
  checklist_category: 'Categoría asignada',
  action_discard: 'Descartar',
  action_save_draft: 'Guardar borrador',
  action_publish: 'Publicar producto',
  action_save: 'Guardar cambios',
  toast_created: 'Producto creado correctamente',
  toast_updated: 'Producto actualizado correctamente',
  toast_deleted: 'Producto eliminado correctamente',
  toast_bulk_status: 'Estado actualizado correctamente',
  toast_bulk_category: 'Categoría asignada correctamente',
  toast_bulk_channels: 'Canales actualizados correctamente',
  toast_bulk_deleted: 'Productos eliminados correctamente',
  toast_error: 'Ha ocurrido un error. Intenta de nuevo.',
  category_create_short: 'Nueva',
  category_create_action: 'Crear categoría',
  category_create_dialog_title: 'Nueva categoría',
  category_create_name_label: 'Nombre',
  category_create_name_placeholder: 'Ej. Velas aromáticas',
  category_create_dialog_confirm: 'Crear',
  category_created: 'Categoría creada',
  import_card_title: 'Importar desde una URL',
  import_card_description:
    'Pega el enlace de un producto y rellenamos el formulario para que solo revises lo importante. Por ahora soportamos Shopify; pronto añadiremos otras plataformas.',
  import_card_placeholder: 'https://tu-tienda.com/products/...',
  import_card_action: 'Importar',
  import_card_footer:
    'Solo Shopify por ahora · esto no guarda el producto, solo llena el formulario.',
  import_success_title: 'Producto importado',
  import_success_description:
    'Revisa los campos antes de publicar. Las imágenes, variantes y precios vienen del producto original.',
  import_success_toast: 'Importamos el producto. Revísalo antes de guardar.',
  import_undo: 'Deshacer importación',
  import_category_hint:
    'Categoría sugerida del origen: "{{name}}". Selecciónala arriba o crea una nueva.',
  import_category_hint_dismiss: 'Listo',
  import_error_invalid_url: 'La URL no es válida.',
  import_error_not_supported:
    'Por ahora solo soportamos URLs de productos de Shopify.',
  import_error_fetch_failed:
    'No pudimos conectar con la tienda. Verifica el enlace o intenta de nuevo.',
  import_error_invalid_json:
    'Esa URL no devolvió un producto Shopify válido. Asegúrate de pegar la URL del producto.',
  import_error_unknown: 'No pudimos importar el producto. Intenta de nuevo.',
  empty_title: 'Sin productos todavía',
  empty_description:
    'Crea tu primer producto para que tus agentes puedan recomendarlo.',
  delete_title: 'Eliminar producto',
  delete_description:
    '¿Estás seguro de que quieres eliminar este producto? Esta acción no se puede deshacer.',
  delete_confirm: 'Eliminar',
  delete_cancel: 'Cancelar',
  image_dropzone_text: 'Arrastra imágenes aquí o haz clic para seleccionar',
  image_dropzone_specs: 'PNG, JPG, WEBP · máx. 5 MB · 1:1 recomendado',
  image_primary: 'Principal',
  image_set_primary: 'Hacer principal',
  image_delete: 'Eliminar',
  pagination_showing: 'Mostrando {{from}}–{{to}} de {{total}}',
  shopify_banner_title: 'Conecta Shopify para sincronizar tu catálogo',
  shopify_banner_description:
    'Cuando conectes, los productos se enlazarán por SKU y el stock se actualizará en tiempo real.',
  shopify_banner_button: 'Conectar Shopify',
  shopify_banner_badge: 'Próximamente',
  table_updated: 'Actualizado',
  table_results: '{{count}} productos',
  pagination_prev: 'Anterior',
  pagination_next: 'Siguiente',
  list_select_all: 'Seleccionar todos',
  list_deselect_all: 'Deseleccionar todo',
  list_filter_label: 'Filtrar por estado',
  list_sort_label: 'Ordenar productos',
  preview_title: 'Vista previa',
  preview_subtitle: 'Cómo se ve cuando Luna lo recomienda en chat.',
  preview_message: '¡Tengo justo lo que buscas! Mira esta opción:',
  preview_view_detail: 'Ver detalle',
  preview_default_name: 'Nombre del producto',
  preview_variants_available: '{{count}} variantes disponibles',
  footer_autosave: 'Cambios guardados automáticamente',
  footer_test_sandbox: 'Probar en Sandbox',
  variants_table_count: 'Variante ({{count}})',
  variants_more_count: '+ {{count}} variantes más',
  image_make_primary: 'Hacer principal',
  image_remove: 'Quitar',
  image_count: '{{count}} / 15',
  bulk_change_status_to: 'Cambiar a',
  bulk_set_active: 'Activar',
  bulk_set_draft: 'Marcar borrador',
  bulk_set_archived: 'Archivar',
  no_match_title: 'No encontramos productos con esos filtros',
  no_match_description:
    'Prueba ajustando la búsqueda, cambiando la categoría o limpiando los filtros activos.',
  no_match_clear: 'Limpiar filtros',
  validation_required: 'Este campo es obligatorio',
  validation_min: 'Debe ser mayor o igual a {{min}}',
  validation_max: 'Máximo {{max}} caracteres',
  validation_must_be_number: 'Debe ser un número válido',
  validation_compare_gt_price:
    'El precio de comparación debe ser mayor al precio',
  sections_title: 'Secciones del producto',
  sections_subtitle:
    'Bloques de información que Luna usa cuando recomienda este producto.',
  sections_templates_label: 'Plantillas',
  sections_template_benefits: 'Beneficios',
  sections_template_features: 'Características',
  sections_template_usage: 'Modo de uso',
  sections_template_specs: 'Especificaciones',
  sections_template_whats_included: 'Qué incluye',
  sections_template_target_audience: 'Para quién es',
  sections_template_care: 'Cuidados',
  sections_template_warranty: 'Garantía',
  sections_template_faq: 'Preguntas frecuentes',
  section_title_placeholder: 'Título de la sección',
  section_content_placeholder:
    'Escribe el contenido que verán Luna y tus otros agentes…',
  section_add_custom: 'Añadir sección personalizada',
  section_remove: 'Eliminar sección',
  section_reorder: 'Reordenar',
  sections_empty:
    'Sin secciones todavía. Empieza con una plantilla o crea una personalizada.',
  sections_cap_reached:
    'Llegaste al máximo de {{max}} secciones. Borra alguna para añadir más.',
  relations_title: 'Productos relacionados',
  relations_subtitle:
    'El agente los usa para sugerir complementos, combos y alternativas.',
  relation_type_upsell: 'Upsell',
  relation_type_cross_sell: 'Cross-sell',
  relation_type_bundle: 'Bundle',
  relation_type_accessory: 'Accesorio',
  relations_search_placeholder: 'Buscar producto del catálogo…',
  relations_add_to: 'Añadir a {{type}}',
  relations_remove: 'Quitar del listado',
  relations_empty: 'Sin productos en {{type}} todavía.',
  relations_bundle_discount: 'Descuento de bundle (%)',
  relations_open_in_new_tab: 'Abrir en nueva pestaña',
};
